export type MovieItem = {
  id: string;
  title: string;
  cover: string;
  category: "电视剧" | "电影";
  genre: string;
  region: string;
  year: number;
  director: string;
  actors: string[];
  synopsis: string;
  updateStatus: string;
  rating: number;
  tags: string[];
  featured: boolean;
  episodes: string[];
};

export const filterGenres = ["全部", "都市", "爱情", "悬疑", "剧情", "家庭", "奇幻", "惊悚", "年代", "喜剧", "古装"];
export const filterRegions = ["全部", "中国大陆", "韩国", "日本", "美国", "中国香港", "中国台湾", "泰国", "英国"];
export const filterYears = ["全部", "2024", "2023", "2022", "2021", "2020"];
export const filterCategories = ["全部", "电视剧", "电影"];

export const movies: MovieItem[] = [
  {
    id: "neighbor-wife",
    title: "邻居的妻子",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20key%20art%20of%20a%20pensive%20elegant%20woman%20in%20a%20quiet%20suburban%20apartment%20corridor%2C%20soft%20window%20light%2C%20muted%20warm%20and%20deep%20navy%20tone%2C%20atmospheric%20melancholic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-01&orientation=portrait",
    category: "电视剧",
    genre: "都市",
    region: "韩国",
    year: 2024,
    director: "金敏哲",
    actors: ["李瑞妍", "朴正勋", "韩素熙", "姜道允"],
    synopsis: "搬进老旧小区的一对年轻夫妻，与住在对面的邻居一家从礼貌寒暄走向彼此试探。平淡的日常之下，每个人都在隐藏自己的疲惫与秘密。当一次意外的深夜停电发生，几个家庭之间原本脆弱的平衡被彻底打破，所有人都不得不直视自己不愿承认的心事。",
    updateStatus: "更新至第12集",
    rating: 8.7,
    tags: ["情感", "都市生活", "人性"],
    featured: true,
    episodes: ["第1集 搬来的邻居", "第2集 对门的灯", "第3集 雨夜的伞", "第4集 越界", "第5集 无人的电梯", "第6集 缝隙", "第7集 各自的秘密", "第8集 停电之夜", "第9集 谎言的代价", "第10集 摊牌", "第11集 崩塌", "第12集 归位"],
  },
  {
    id: "late-night-confession",
    title: "深夜的告白",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20romance%20film%20poster%20key%20art%20of%20two%20silhouettes%20standing%20apart%20under%20a%20streetlamp%20at%20midnight%2C%20rain%20slicked%20street%2C%20warm%20orange%20glow%20against%20dark%20navy%20sky%2C%20lonely%20tender%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-02&orientation=portrait",
    category: "电影",
    genre: "爱情",
    region: "韩国",
    year: 2023,
    director: "崔恩珠",
    actors: ["宋允浩", "林智雅"],
    synopsis: "一名习惯在深夜电台讲述别人故事的 DJ，某天接进了一通只肯留下沉默的电话。他顺着微弱的声音线索寻找发声的人，却发现对方正是自己早已疏远的那个人。一场跨越整座城市的夜行，让两个错过多年的人重新面对当年没说出口的话。",
    updateStatus: "已上线",
    rating: 8.2,
    tags: ["都市爱情", "深夜", "治愈"],
    featured: true,
    episodes: [],
  },
  {
    id: "fog-hunter",
    title: "迷雾追凶",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20poster%20key%20art%20of%20a%20detective%20in%20a%20long%20coat%20walking%20through%20dense%20fog%20in%20a%20dim%20city%20alley%2C%20cold%20deep%20navy%20shadows%20with%20a%20single%20orange%20light%2C%20tense%20mysterious%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-03&orientation=portrait",
    category: "电视剧",
    genre: "悬疑",
    region: "中国大陆",
    year: 2024,
    director: "周立川",
    actors: ["张奕辰", "苏晓楠", "黄志国", "陈雨"],
    synopsis: "连续三起看似互不相关的案件，唯一的共同点是现场总会留下一枚被摩旧的旧车票。退休刑警与年轻法医被迫组成临时搭档，沿着这张车票追进城市被遗忘的旧城区。真相越近，他们越发现当年那桩悬案从未真正结案。",
    updateStatus: "更新至第16集",
    rating: 8.9,
    tags: ["刑侦", "悬疑", "烧脑"],
    featured: true,
    episodes: ["第1集 旧车票", "第2集 沉默的证人", "第3集 雨夜行踪", "第4集 错位的监控", "第5集 第二个现场", "第6集 消失的档案", "第7集 疑点", "第8集 交叉点", "第9集 熟悉的陌生人", "第10集 反转", "第11集 旧城区", "第12集 当年的雨", "第13集 对峙", "第14集 拼图", "第15集 收网", "第16集 真相之外"],
  },
  {
    id: "city-light",
    title: "城市之光",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20poster%20key%20art%20of%20a%20lone%20figure%20standing%20on%20a%20rooftop%20overlooking%20a%20vast%20glowing%20city%20skyline%20at%20dusk%2C%20warm%20amber%20lights%20against%20deep%20blue%20haze%2C%20reflective%20hopeful%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-04&orientation=portrait",
    category: "电影",
    genre: "剧情",
    region: "中国大陆",
    year: 2022,
    director: "许安然",
    actors: ["刘子昂", "孙可欣"],
    synopsis: "一名在城市底层奔波的快递员，因为一次深夜送错的包裹，意外卷入一群陌生人的人生。他用最笨拙的方式试图帮助每一个人，自己却始终站在光的背面。直到某个凌晨，他终于决定为自己的生活按下一次重来的按钮。",
    updateStatus: "已上线",
    rating: 8.4,
    tags: ["现实", "人文", "励志"],
    featured: false,
    episodes: [],
  },
  {
    id: "spring-letter",
    title: "春日来信",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20youth%20romance%20poster%20key%20art%20of%20a%20girl%20holding%20an%20old%20letter%20beneath%20blooming%20cherry%20blossoms%2C%20soft%20spring%20light%2C%20gentle%20pink%20and%20warm%20cream%20tones%2C%20nostalgic%20tender%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-05&orientation=portrait",
    category: "电视剧",
    genre: "爱情",
    region: "日本",
    year: 2023,
    director: "小林凉介",
    actors: ["新垣里美", "木村启太", "石田真央"],
    synopsis: "整理祖母旧屋时，女孩发现一叠从未寄出的信件，收信人正是自己从未见过的祖父。带着信件她踏上寻找过去的旅程，在与小镇居民的交谈中，拼出一个被时间掩埋的春天。而她的第二人生，也在这趟旅程里悄然开始。",
    updateStatus: "更新至第10集",
    rating: 8.5,
    tags: ["治愈", "青春", "成长"],
    featured: false,
    episodes: ["第1集 旧屋", "第2集 未寄的信", "第3集 小镇", "第4集 名字的秘密", "第5集 春天的站台", "第6集 母亲的故事", "第7集 错过", "第8集 重逢", "第9集 一封回信", "第10集 春日再临"],
  },
  {
    id: "warmth-of-years",
    title: "岁月的温度",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%20key%20art%20of%20an%20old%20dining%20table%20with%20steaming%20dishes%20and%20empty%20chairs%20in%20a%20warm%20lived-in%20home%2C%20golden%20afternoon%20light%20through%20curtains%2C%20warm%20amber%20and%20brown%20tones%2C%20nostalgic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-06&orientation=portrait",
    category: "电视剧",
    genre: "家庭",
    region: "中国大陆",
    year: 2021,
    director: "何建国",
    actors: ["王玉兰", "李长河", "周小雨"],
    synopsis: "一家传承了三代的街角小馆，因为拆迁通知面临关闭。年迈的母亲、矛盾不断的兄妹、突然回乡的小女儿，都被重新拉回同一张饭桌前。在争吵与和解之间，这个家重新找回了被岁月冲淡的温度。",
    updateStatus: "完结",
    rating: 8.6,
    tags: ["家庭", "年代", "温情"],
    featured: false,
    episodes: ["第1集 拆迁通知", "第2集 回家", "第3集 一桌饭", "第4集 旧账", "第5集 母亲的手艺", "第6集 谁来做主", "第7集 兄妹之间", "第8集 最后一单", "第9集 招牌", "第10集 饭还热着"],
  },
  {
    id: "seaside-cafe",
    title: "海边咖啡馆",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20gentle%20drama%20poster%20key%20art%20of%20a%20small%20seaside%20cafe%20with%20warm%20lights%20at%20blue%20hour%2C%20calm%20sea%20waves%20and%20open%20sky%2C%20warm%20amber%20interior%20against%20deep%20teal%20evening%2C%20peaceful%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-07&orientation=portrait",
    category: "电影",
    genre: "剧情",
    region: "日本",
    year: 2024,
    director: "森川一郎",
    actors: ["山口知子", "田中悠斗"],
    synopsis: "经营海边咖啡馆的中年女人，每天为形形色色的过客煮一杯咖啡。一个沉默的年轻旅人留下成为店员，两人在日复一日的海潮声里，慢慢讲出各自不愿提起的过去。海风吹走的不是遗憾，而是重新开始的勇气。",
    updateStatus: "已上线",
    rating: 8.3,
    tags: ["治愈", "生活", "海边"],
    featured: false,
    episodes: [],
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20legal%20thriller%20poster%20key%20art%20of%20a%20courtroom%20spotlight%20falling%20on%20an%20empty%20witness%20stand%2C%20dark%20navy%20interior%20with%20cold%20light%20and%20a%20hint%20of%20orange%2C%20tense%20dramatic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-08&orientation=portrait",
    category: "电视剧",
    genre: "悬疑",
    region: "美国",
    year: 2024,
    director: "Daniel Cross",
    actors: ["Emma Hayes", "Jason Bell", "Nora White"],
    synopsis: "一位聋哑证人的手语陈述成为一桩命案的关键，然而没有任何人真正理解他到底看见了什么。年轻的女律师坚持为被告辩护，却发现整个案子的证据链都建立在被误读的沉默之上。当庭审逼近终点，她必须在真相与胜负之间做出选择。",
    updateStatus: "更新至第8集",
    rating: 8.8,
    tags: ["律政", "悬疑", "推理"],
    featured: false,
    episodes: ["第1集 沉默的证人", "第2集 被误读的手语", "第3集 证据链", "第4集 疑点重重", "第5集 庭审", "第6集 反转证词", "第7集 真相的方向", "第8集 判决之前"],
  },
  {
    id: "against-light",
    title: "逆光而行",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20key%20art%20of%20a%20runner%20silhouetted%20against%20a%20blazing%20sunset%20on%20a%20long%20empty%20road%2C%20strong%20rim%20light%20and%20deep%20navy%20shadows%2C%20windy%20determined%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-09&orientation=portrait",
    category: "电影",
    genre: "剧情",
    region: "中国香港",
    year: 2023,
    director: "陈伟东",
    actors: ["郑家俊", "梁静雯"],
    synopsis: "因伤退役的长跑运动员回到旧城，成为一名普通的外卖骑手。他不再追逐赛道，却始终无法放下那个终点线。当一群社区少年偷偷跟着他训练，他被迫重新面对自己失败的那一天，也在他们身上找回了奔跑的意义。",
    updateStatus: "已上线",
    rating: 8.1,
    tags: ["运动", "励志", "人生"],
    featured: false,
    episodes: [],
  },
  {
    id: "starry-promise",
    title: "星空下的约定",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20romance%20poster%20key%20art%20of%20two%20young%20people%20lying%20on%20a%20grassy%20hill%20under%20a%20vast%20star-filled%20night%20sky%2C%20deep%20indigo%20and%20warm%20soft%20glow%2C%20dreamy%20hopeful%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-10&orientation=portrait",
    category: "电视剧",
    genre: "爱情",
    region: "泰国",
    year: 2022,
    director: "Preecha Wong",
    actors: ["Napat S.", "Mali K.", "Chai P."],
    synopsis: "两个来自不同城市的高中生，在一次天文夏令营相遇，约定十年后再回到同一片星空下。毕业后天各一方，各自经历着生活的起伏。当年的那句约定，成了支撑他们熬过漫长黑夜的唯一星光。",
    updateStatus: "完结",
    rating: 8.2,
    tags: ["青春", "爱情", "成长"],
    featured: false,
    episodes: ["第1集 夏令营", "第2集 望远镜", "第3集 第一个夜晚", "第4集 约定", "第5集 分别", "第6集 海边的信", "第7集 城市", "第8集 重逢的岔路", "第9集 十年", "第10集 同一片星空"],
  },
  {
    id: "secret-garden",
    title: "秘密花园",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20mystery%20drama%20poster%20key%20art%20of%20a%20garden%20gate%20half%20hidden%20by%20ivy%20with%20warm%20lantern%20light%2C%20lush%20green%20and%20deep%20navy%20shade%2C%20secretive%20intimate%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-11&orientation=portrait",
    category: "电视剧",
    genre: "都市",
    region: "韩国",
    year: 2024,
    director: "尹世拉",
    actors: ["徐智媛", "赵民赫", "白恩菲"],
    synopsis: "一栋位于市中心的百年老宅，花园常年紧锁。新搬来的租客偶然得到一把生锈的钥匙，从此走进了一个被两个家族共同守护几十年的秘密。花园里盛开的每一朵花，都对应着一段无人敢提的往事。",
    updateStatus: "更新至第14集",
    rating: 8.4,
    tags: ["都市", "秘密", "群像"],
    featured: false,
    episodes: ["第1集 锈钥匙", "第2集 上锁的门", "第3集 花的名字", "第4集 旧主人", "第5集 两家人", "第6集 夜里的人影", "第7集 一段录音", "第8集 谁在意", "第9集 花开花落", "第10集 真相的入口", "第11集 对峙", "第12集 父亲的信", "第13集 花园深处", "第14集 重开的花园"],
  },
  {
    id: "time-post-office",
    title: "时光邮局",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20film%20poster%20key%20art%20of%20an%20old%20post%20office%20filled%20with%20glowing%20floating%20envelopes%2C%20warm%20amber%20light%20and%20deep%20navy%20shadows%2C%20magical%20nostalgic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-12&orientation=portrait",
    category: "电影",
    genre: "奇幻",
    region: "中国大陆",
    year: 2023,
    director: "孟云舟",
    actors: ["顾晚", "程亦凡"],
    synopsis: "城市角落有一间只在凌晨营业的邮局，据说能把信寄给过去的某一天。一个想挽回遗憾的年轻人前来投递，却逐渐发现，每一封被寄出的信都会悄悄改变另一个人的人生。他终于明白，真正的告别不是改写过去，而是好好说再见。",
    updateStatus: "已上线",
    rating: 8.5,
    tags: ["奇幻", "治愈", "温情"],
    featured: false,
    episodes: [],
  },
  {
    id: "undercurrent",
    title: "暗涌",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%20key%20art%20of%20a%20rainy%20harbor%20at%20night%20with%20reflected%20neon%20lights%20rippling%20on%20dark%20water%2C%20deep%20navy%20and%20muted%20orange%20reflections%2C%20tense%20noir%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-13&orientation=portrait",
    category: "电视剧",
    genre: "悬疑",
    region: "中国香港",
    year: 2022,
    director: "林国栋",
    actors: ["吴浩天", "曾诗雅", "马文彬"],
    synopsis: "海港城市里，一桩看似普通的走私案牵出盘根错节的地下网络。卧底警员在正义与生存之间越陷越深，逐渐分不清自己到底站在哪一边。暗流之下，没有谁的手是干净的。",
    updateStatus: "完结",
    rating: 8.7,
    tags: ["警匪", "悬疑", "港风"],
    featured: false,
    episodes: ["第1集 潮水", "第2集 线人", "第3集 交易", "第4集 内鬼", "第5集 一枪", "第6集 码头", "第7集 断线", "第8集 谁是朋友", "第9集 反水", "第10集 收网", "第11集 代价", "第12集 退了潮"],
  },
  {
    id: "old-alley",
    title: "老巷深处",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20era%20family%20drama%20poster%20key%20art%20of%20a%20narrow%20old%20town%20alley%20with%20hanging%20laundry%20and%20a%20single%20warm%20street%20lamp%2C%20golden%20evening%20light%2C%20warm%20amber%20and%20earth%20brown%20tones%2C%20nostalgic%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-14&orientation=portrait",
    category: "电视剧",
    genre: "家庭",
    region: "中国大陆",
    year: 2020,
    director: "赵德海",
    actors: ["李桂芳", "周大勇", "何小满"],
    synopsis: "老巷里住着几户再普通不过的人家，孩子的学费、老人的药费、夫妻的争吵填满了日复一日的生活。邻里之间既互相帮衬，也暗暗较劲。在时代变迁中，这条巷子的人们用自己的方式守着属于他们的体面。",
    updateStatus: "完结",
    rating: 8.3,
    tags: ["年代", "群像", "生活"],
    featured: false,
    episodes: ["第1集 老巷", "第2集 隔壁的哭声", "第3集 学费", "第4集 一张传单", "第5集 谁对谁错", "第6集 年夜饭", "第7集 远行", "第8集 巷口的信", "第9集 老屋", "第10集 巷子还在"],
  },
  {
    id: "wind-rider",
    title: "追风少年",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sports%20youth%20poster%20key%20art%20of%20a%20cyclist%20racing%20down%20a%20sunlit%20coastal%20road%2C%20motion%20blur%20and%20warm%20golden%20light%20against%20deep%20blue%20sky%2C%20energetic%20free%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-15&orientation=portrait",
    category: "电影",
    genre: "剧情",
    region: "中国大陆",
    year: 2021,
    director: "范立行",
    actors: ["苏梓航", "林一诺"],
    synopsis: "海边小镇的少年痴迷自行车竞技，却因家庭窘境连比赛报名费都凑不出。他靠着一辆拼凑的旧车和一股不服输的劲头，从县城的土路一路骑向更大的赛场。风不会等人，但他学会了追上风。",
    updateStatus: "已上线",
    rating: 7.9,
    tags: ["青春", "运动", "热血"],
    featured: false,
    episodes: [],
  },
  {
    id: "seventh-night",
    title: "第七个夜晚",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20psychological%20thriller%20poster%20key%20art%20of%20a%20dark%20bedroom%20with%20a%20single%20door%20ajar%20and%20a%20cold%20streak%20of%20light%2C%20deep%20navy%20black%20tones%20with%20a%20hint%20of%20orange%2C%20unsettling%20eerie%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-16&orientation=portrait",
    category: "电影",
    genre: "惊悚",
    region: "韩国",
    year: 2023,
    director: "朴在勋",
    actors: ["郑多恩", "金时厚"],
    synopsis: "一个搬进单身公寓的女人发现，每到夜里楼下都会传来诡异的敲击声。她记录下每一个夜晚，却发现自己记忆中的时间段开始出现空白。第七个夜晚到来时，她终于分不清是这栋楼有秘密，还是她自己出了问题。",
    updateStatus: "已上线",
    rating: 7.8,
    tags: ["悬疑", "惊悚", "心理"],
    featured: false,
    episodes: [],
  },
  {
    id: "break-of-dawn",
    title: "破晓时分",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20poster%20key%20art%20of%20a%20lone%20figure%20walking%20across%20a%20misty%20field%20at%20dawn%2C%20first%20soft%20light%20breaking%20over%20the%20horizon%2C%20muted%20blue%20haze%20with%20warm%20orange%20glow%2C%20hopeful%20solemn%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-17&orientation=portrait",
    category: "电视剧",
    genre: "年代",
    region: "中国大陆",
    year: 2021,
    director: "钱守正",
    actors: ["陆沉", "沈书宁", "高远"],
    synopsis: "动荡年代里，一群怀抱理想的年轻人从校园走向广阔的天地。他们在信念与现实之间反复挣扎，有人坚守，有人妥协，也有人悄然改变。当破晓来临，他们终于看清自己走过的路。",
    updateStatus: "完结",
    rating: 8.6,
    tags: ["年代", "理想", "群像"],
    featured: false,
    episodes: ["第1集 出发", "第2集 第一个冬天", "第3集 选择", "第4集 分岔路", "第5集 一封家书", "第6集 重逢", "第7集 信念", "第8集 分别", "第9集 长夜", "第10集 破晓"],
  },
  {
    id: "distant-her",
    title: "遥远的她",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20romance%20drama%20poster%20key%20art%20of%20a%20woman%20looking%20out%20a%20train%20window%20at%20passing%20towns%2C%20warm%20afternoon%20light%2C%20soft%20amber%20and%20dusty%20blue%20tones%2C%20wistful%20lonely%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-18&orientation=portrait",
    category: "电影",
    genre: "爱情",
    region: "中国台湾",
    year: 2020,
    director: "许清和",
    actors: ["林语晴", "简志豪"],
    synopsis: "男生在毕业那年送女孩上了南下的火车，说好第二年春天就去找她。可这一走，就是十年。当两人在多年后的旧车站意外重逢，那些没说出口的话，还能不能赶上早已错过的班次。",
    updateStatus: "已上线",
    rating: 8.0,
    tags: ["爱情", "文艺", "遗憾"],
    featured: false,
    episodes: [],
  },
  {
    id: "city-night-return",
    title: "都市夜归人",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20key%20art%20of%20a%20lone%20commuter%20waiting%20on%20an%20empty%20subway%20platform%20late%20at%20night%2C%20cold%20deep%20blue%20tones%20with%20warm%20platform%20lights%2C%20quiet%20reflective%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-19&orientation=portrait",
    category: "电视剧",
    genre: "都市",
    region: "中国大陆",
    year: 2024,
    director: "叶知秋",
    actors: ["程亦然", "温以宁", "何书航"],
    synopsis: "深夜的末班地铁上，总有一群不肯早点回家的人。加班的白领、刚下夜班的护士、跑完最后一单的司机、无处可去的学生。他们在同一节车厢短暂相遇，又在下一站各自散开，各自背负着这座城市不为人知的重量。",
    updateStatus: "更新至第18集",
    rating: 8.3,
    tags: ["都市", "群像", "现实"],
    featured: false,
    episodes: ["第1集 末班车", "第2集 加班的人", "第3集 夜班护士", "第4集 最后一单", "第5集 无座", "第6集 一场错过", "第7集 陌生人", "第8集 手机里的秘密", "第9集 天亮之前", "第10集 各自的路", "第11集 雨夜", "第12集 重逢的车厢", "第13集 选择", "第14集 老同学", "第15集 搬家", "第16集 一封辞呈", "第17集 告别", "第18集 城市的灯"],
  },
  {
    id: "foggy-capital",
    title: "雾都疑云",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20period%20mystery%20poster%20key%20art%20of%20a%20gaslit%20cobblestone%20victorian%20street%20shrouded%20in%20thick%20fog%2C%20warm%20amber%20lamplight%20against%20deep%20navy%20darkness%2C%20gothic%20suspenseful%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mv-20&orientation=portrait",
    category: "电视剧",
    genre: "悬疑",
    region: "英国",
    year: 2023,
    director: "Arthur Finch",
    actors: ["Oliver Reed", "Clara Moore", "Henry Shaw"],
    synopsis: "浓雾笼罩的旧城接连发生离奇失踪案，唯一的线索是一枚枚遗落在巷口的铜制纽扣。一位被停职的警探与一名推理小说作家联手追查，越深入越发现，线索指向的竟是一个所有人都熟悉的体面名字。",
    updateStatus: "更新至第9集",
    rating: 8.5,
    tags: ["悬疑", "推理", "复古"],
    featured: false,
    episodes: ["第1集 铜纽扣", "第2集 雾中人", "第3集 失踪名单", "第4集 作家来访", "第5集 旧报纸", "第6集 体面的家族", "第7集 第二个雾夜", "第8集 内线", "第9集 雾散之时"],
  },
];